import PropTypes from 'prop-types';
import React from 'react';

const EmptyTubeIcon = ({ title = 'Affiliate Icon', titleId, ...props }) => (
	<svg
		aria-labelledby={titleId}
		fill="none"
		height={200}
		viewBox="0 0 184 200"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		{title ? <title id={titleId}>{title}</title> : null}
		<ellipse cx={92} cy={172.975} fill="#F8F5FC" rx={92} ry={25} />
		<path
			clipRule="evenodd"
			d="M172.744 172.744c-12.946 12.946-33.925 12.934-46.86 0L10.11 56.97l46.86-46.86 115.774 115.774c12.935 12.935 12.935 33.925 0 46.86Z"
			fill="#E7D7FF"
			fillRule="evenodd"
		/>
		<path
			clipRule="evenodd"
			d="M53.907.025C73.55.373 82.301 19.781 77.163 34.97c-5.935 17.546-24.591 36.505-42.204 42.204C19.063 82.312.07 73.382.002 53.391-.042 34.869 35.397-.312 53.907.025Z"
			fill="#CEB5F7"
			fillRule="evenodd"
		/>
		<path
			clipRule="evenodd"
			d="M43.833 1.63C61.457-4.06 71.138 5.622 65.45 23.246c-5.688 17.624-24.58 36.527-42.204 42.204C5.623 71.139-4.059 61.457 1.63 43.833 7.317 26.209 26.21 7.317 43.833 1.629Z"
			fill="#E7D7FF"
			fillRule="evenodd"
		/>
		<path
			clipRule="evenodd"
			d="M41.421 13.431c11.107-4.353 16.581 1.133 12.24 12.24-4.353 11.105-16.873 23.636-27.98 27.978-11.105 4.353-16.58-1.133-12.238-12.24 4.352-11.105 16.872-23.636 27.978-27.978Z"
			fill="#CEB5F7"
			fillRule="evenodd"
		/>
	</svg>
);

EmptyTubeIcon.propTypes = {
	title: PropTypes.string,
	titleId: PropTypes.string,
};

export default EmptyTubeIcon;
